<template>
  <div class="pricing-container-v3">
    <link rel="stylesheet" :href="`${presenterDomain}/pricing.css`">
    <div @click="scrollToPlanUpgradePlan">
      <BannerSuccess
        v-if="isValidPromoCode"
        class="mb-3 cursor-pointer"
      >
        {{ $i18nPresenter.t('Your promotion is ready! Select a plan below to apply your discount at checkout.') }}
      </BannerSuccess>
    </div>

    <div class="pricing-container" :class="{'pricing-container-mobile': fromMobile}">
      <div id="pricing-compare">
        <div
          v-if="$store.state.plan && $store.state.plan.type !== 'pro-yearly' &&
            $store.state.plan.group !== 'white-label'"
        >
          <div class="pricing-plan-edu" v-if="isShowBackToNonEdu">
            <aha-antd-button
              class="back-non-edu-plan"
              icon-name="left_direction"
              variant="link"
              icon-view-box="0 0 16 16"
              @click="backToNonEducational()"
            >
              {{ $i18nPresenter.t('Back to standard plans') }}
            </aha-antd-button>
            <div class="pricing-toggle-title">
              {{ $i18nPresenter.t('Educational plans') }}
            </div>
            <div class="pricing-decs-edu">
              {{ $i18nPresenter.t('Special pricing for teachers, students, and nonprofit organisations.') }}
            </div>
          </div>

          <div v-else :class="{'show-edu-plan': isShowBackToNonEdu}" class="pricing-desktop ">
            <div class="pricing-toggle-wrapper">
              <div :class="{'font-bold-v2': !isAnnual}" class="aha__save">
                {{ $i18nPresenter.t('Monthly') }}
              </div>
              <toggle-button
                :sync="true"
                :value="isAnnual"
                :width="45"
                :height="28"
                class="mb-0"
                :color="{
                  checked: '#6A1EBB',
                  unchecked: '#D3D7E1'
                }"
                @change="toggleButtonSwitch()"
              />
              <div class="user-pricing-yearly" :class="{'font-bold-v2': isAnnual}">
                {{ $i18nPresenter.t('Yearly') }}
                <div class="pricing-label-discount">
                  <p>{{ $i18nPresenter.t('Save 67%') }}</p>
                </div>
              </div>
            </div>
          </div>
          <!--      add css taiwind mobile show up -->
          <div class="pricing-desktop ">
            <PricingDesktop
              :planName="planName"
              :toggleButtonSwitch="toggleButtonSwitch"
              @learnMore="learnMore"
              :permission="permission"
              @upgradePlan="upgradePlan"
              :isShowBackToNonEdu="isShowBackToNonEdu"
            />

            <div class="title-open-edu" v-if="isShowTitleOpenEdu">
              <span>
                <b>{{ $i18nPresenter.t('Educational plans') }}</b>
              </span> —  {{ $i18nPresenter.t('Special rates for teachers, students and nonprofit organisations.') }}
              <aha-antd-button class="--link" variant="link" @click="openEducation()">
                {{ $i18nPresenter.t('Learn more') }}
                <aha-icon
                  name="right_direction"
                  width="12"
                  height="12"
                  viewBox="0 0 17 16"
                />
              </aha-antd-button>
            </div>
          </div>
        </div>
        <BulkPricing v-if="canShowBulkPricingSection" />
        <ComparePlansSection
          :billingCycle="planName"
          :togglePlan="_togglePlan"
          :permission="permission"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Config from '@/config'
import Utils from '@/util'
import PricingDesktop from './PricingDesktop.vue'
import ComparePlansSection from './ComparePlansSection.vue'

import eventCategories from '@/constant/eventCategories'
import EventBus from '@/eventBus'
import BulkPricing from '@/components-v2/my-plan/user-pricing-v3/BulkPricing.vue'
import BannerSuccess from '@/components-v2/my-plan/BannerSuccess.vue'

const PLAN_GROUPS = ['annual', 'one-time', 'educational', 'monthly']
export default {
  name: 'UserPricing',
  components: {
    BannerSuccess,
    BulkPricing,
    ComparePlansSection,
    PricingDesktop,
  },
  props: {
    permission: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      hiddenPlanEdu: true,
      showTitleOpenEdu: true,
      planName: 'annual',
      planColour: '',
      showDetails: false,
      domain: '',
      fromMobile: false,
      presenterDomain: Config.presenterDomain,
    }
  },
  computed: {
    ...mapGetters([
      'currentUserIsTeamOwnerOrAdmin',
      'isTeamCreatedByCustomerSuccess',
    ]),
    ...mapState({
      currentUser: (state) => state.currentUser,
      currentAccount: (state) => state.currentAccount,
      isValidPromoCode: (state) => state.isValidPromoCode,
    }),
    isShowBackToNonEdu() {
      return !this.showTitleOpenEdu && this.abTestOpenEdu
    },
    isAnnual() {
      return this.planName == 'annual'
    },
    isShowTitleOpenEdu() {
      return this.showTitleOpenEdu && this.abTestOpenEdu
    },
    isHiddenSwitchPlanEdu() {
      return this.hiddenPlanEdu && this.abTestOpenEdu
    },
    abTestOpenEdu() {
      return true
    },
    canShowBulkPricingSection() {
      if (!this.currentAccount || !this.currentAccount.id) return true
      return this.currentUserIsTeamOwnerOrAdmin &&
          !this.isTeamCreatedByCustomerSuccess &&
          (this.currentAccount.plan == 'free' || this.currentAccount.plan == null) &&
          this.planName !== 'educational'
    },
  },
  mounted() {
    this.domain = Config.domain
    if (PLAN_GROUPS.includes(Utils.getParamValue('planGroup'))) {
      this.planName = Utils.getParamValue('planGroup')
    }

    EventBus.$on('clickShowEduPlan', () => {
      this.openEducation(true)
    })
  },
  destroyed() {
    EventBus.$off('clickShowEduPlan')
  },
  methods: {
    toggleButtonSwitch() {
      if (this.planName === 'annual') {
        this._togglePlan('monthly')
      } else {
        this._togglePlan('annual')
      }
    },
    scrollToPlanUpgradePlan() {
      const pricingCompareDom = document.getElementById('upgrade-your-plan')
      pricingCompareDom.scrollIntoView({ behavior: 'smooth' })
    },
    isProPlan() {
      return this.$store.state.plan.group == 'pro'
    },
    isWhiteLabel() {
      return this.$store.state.plan.group === 'white-label'
    },
    openEducation(fromMobile = false) {
      Utils.mixpanelTracking('My plan', 'Show Plan Edu')
      this.fromMobile = fromMobile
      this._togglePlan('educational')
      this.scrollToPlanUpgradePlan()
    },
    backToNonEducational() {
      Utils.mixpanelTracking('My plan', 'Show Non-Edu Plans')
      this.showTitleOpenEdu = true
      this.$emit('back-to-non-edu', true)
      this._togglePlan('annual')
    },
    learnMore(plan) {
      Utils.mixpanelTracking(eventCategories.MY_PLAN, 'Learn more', plan)
      const element = document.getElementById('sticky-wrapper')
      const top = element.offsetTop - 50
      window.scrollTo(0, top)
    },
    upgradePlan(planType) {
      Utils.mixpanelTracking('My plan > Upgrade > Top', 'Upgrade', planType)
      setTimeout(() => {
        window.location.href = `${Config.presenterDomain}/apps/upgrade/${planType}`
      }, 500)
    },
    togglePlanEduByPlan(plan) {
      if (plan !== 'educational') {
        this.showTitleOpenEdu = true
        this.hiddenPlanEdu = true
      } else {
        this.showTitleOpenEdu = false
      }
    },

    _togglePlan(plan) {
      if (!plan) return
      this.togglePlanEduByPlan(plan)
      this.planName = plan
      Utils.mixpanelTracking(
        eventCategories.MY_PLAN,
        'Change Plan Tab',
        plan,
      )
    },
    _showMobileDetailsPlan(planColour, planName) {
      const showDetails = this.$refs[`show-${planColour}${planName}`]
      const hideDetails = this.$refs[`hide-${planColour}${planName}`]
      const details = this.$refs[`details-${planColour}${planName}`]
      showDetails.classList.remove('active')
      hideDetails.classList.add('active')
      details.classList.add('active')
      this.planColour = planColour
      this.planName = planName
    },
    _hideMobileDetailsPlan(planColour, planName) {
      const showDetails = this.$refs[`show-${planColour}${planName}`]
      const hideDetails = this.$refs[`hide-${planColour}${planName}`]
      const details = this.$refs[`details-${planColour}${planName}`]
      showDetails.classList.add('active')
      hideDetails.classList.remove('active')
      details.classList.remove('active')
    },
  },
}
</script>

<style lang="scss" module>
</style>
